// extracted by mini-css-extract-plugin
module.exports = {"play-button--play-btn":"play-button_play-button--play-btn__GaNaM"};